export default __webpack_public_path__ + "static/media/clear-day.1b804c62.svg";